// Which side of the books a document type is on, by acctg_docu_type.docu_type_code:
// money going out → a vendor's document; money coming in → a customer's; a report /
// other document (or no type yet) → either.
export type PartySide = 'vendor' | 'customer' | 'any';

export const VENDOR_SIDE_CODES = new Set(['EXPS', 'STMT', 'PINV', 'CRMM', 'RFNDRcvd', 'ETRSent', 'SOARcvd', 'CHK', 'PMT', 'QuoteRcvd']);
export const CUSTOMER_SIDE_CODES = new Set(['SINV', 'CMSales', 'DEP', 'RFNDIssued', 'ETRcvd', 'QuoteSent', 'SOASent']);

export function partySideOf(docuTypeCode: string | null | undefined): PartySide {
  const code = String(docuTypeCode || '');
  return VENDOR_SIDE_CODES.has(code) ? 'vendor' : CUSTOMER_SIDE_CODES.has(code) ? 'customer' : 'any';
}
